import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/* bs4 */
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

/* http */
import http from '@/http'
Vue.use(http)

/* GTM */
import VueGtm from 'vue-gtm'
Vue.use(VueGtm, {
  id: 'GTM-T4XFMFX'
})

/* vue sweet alert */
// noinspection SpellCheckingInspection
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
Vue.use(VueSweetalert2)

/* inputmask */
import Inputmask from 'inputmask'
Vue.directive('mask', {
  bind(el, binding) {
    Inputmask(binding.value).mask(el)
  }
})

/* clipboard */
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

/* countdown timer */
import vueAwesomeCountdown from 'vue-awesome-countdown'
Vue.use(vueAwesomeCountdown, 'vac')

/* vue-mq */
import VueMQ from 'vue-mq'
Vue.use(VueMQ, {
  breakpoints: {
    phone: 812,
    tablet: 1366,
    desktop: Infinity
  }
})

/* i18n */
import VueI18n from 'vue-i18n'
import { messages } from '@/translations'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ru',
  messages,
  silentTranslationWarn: true
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
